import { memo } from 'react'
import { SearchAutocomplete } from '@quickmd-llc/design-system'
import { removeEmojis } from '../../utils/common'

type Props = {
  searchText: string
  onChangeSearchText: (e: { target: { value: string } }) => void
  additionalClassName?: string
  /** Renders the field in the design system's error state (red border + icon). */
  error?: boolean
  collapsible?: boolean
  placeholder?: string
  /** Passed by ClinicMembers to contextually identify the search origin; not consumed internally. */
  clinic?: boolean
}

// Thin wrapper around the design-system SearchAutocomplete. Admin's search is a filter
// (no results dropdown), so we run it with `showResults={false}`. The `collapsible` prop
// (added to the DS component) provides the icon-expands-to-input affordance. We keep the
// existing event-shaped `onChangeSearchText` API so current callers stay unchanged, and
// preserve the emoji-stripping behavior.
const SearchComponent = memo(
  ({
    searchText,
    onChangeSearchText,
    additionalClassName,
    error,
    collapsible,
    placeholder = 'Search by...',
  }: Props) => {
    const handleChange = (value: string) => {
      if (value === removeEmojis(value)) {
        onChangeSearchText({ target: { value } })
      }
    }

    return (
      <SearchAutocomplete
        shouldShowClear
        showResults={false}
        value={searchText}
        onChange={handleChange}
        searchResults={[]}
        placeholder={placeholder}
        {...(additionalClassName !== undefined ? { className: additionalClassName } : {})}
        {...(error !== undefined ? { error } : {})}
        {...(collapsible !== undefined ? { collapsible } : {})}
      />
    )
  },
)

export { SearchComponent }
export default SearchComponent
